import { pList, rOyakProjeToplamHakedis, rValue } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKPROJETOPLAMHAKEDISLISTE,
    new Api.Bilgi.OyakProjeToplamHakedisListe().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakProjeToplamHakedis> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakProjeToplamHakedis> =>
  ActionFunctions.action_async_complete_api<rOyakProjeToplamHakedis>(
    ActionSubTypes.API_OYAKPROJETOPLAMHAKEDISLISTE,
    {
      Data: new Collection(((data?.Value?.Data as unknown) as any) || []),
      min_yil: data?.Value?.min_yil || 0,
      max_yil: data?.Value?.max_yil || 0,
    },
    error
  );
